import { formatUsdValue } from '@/utils/formatUsdValue';
import useValidBitcoinPrice from '@/utils/useValidBitcoinPrice';

import { useWalletSats } from './useWalletSats';

export const useBitcoinBalanceUSD = () => {
  const walletSats = useWalletSats();
  const bitcoinPrice = useValidBitcoinPrice();

  if (bitcoinPrice === null) {
    return 0;
  }

  const total = (walletSats / 100_000_000) * bitcoinPrice.price;

  return formatUsdValue(total);
};
